import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300" style={{
    backgroundColor: '#0283C7',
    boxShadow: scrolled ? '0 4px 24px rgba(2,131,199,0.35)' : 'none'
  }} data-id="element-121">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-122">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-123">
          {/* Logo */}
          <a href="/" className="flex items-center flex-shrink-0" data-id="element-124">
            <img src="https://cdn.magicpatterns.com/uploads/3rDr76G2xKESSQAdSYdtBE/BlueCactus_Power_Washing_Logo_White.svg" alt="Blue Cactus Power Washing" className="h-10" data-id="element-125" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" aria-label="Main navigation" data-id="element-126">
            {['Services', 'About Us', 'Locations', 'Reviews', 'Contact Us'].map(link => <a key={link} href={`#${link.toLowerCase().replace(/\s+/g, '-')}`} className="font-medium text-sm text-white transition-opacity hover:opacity-75" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-127">
                  {link}
                </a>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-4" data-id="element-128">
            <a href="tel:4805998442" className="flex items-center gap-2 font-semibold text-sm text-white transition-opacity hover:opacity-80" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-129">
              <PhoneIcon className="h-4 w-4" data-id="element-130" />
              (480) 599-8442
            </a>
            <a href="#contact" className="font-bold text-sm px-5 py-2.5 rounded-lg transition-all duration-200 hover:scale-105" style={{
            backgroundColor: '#ffffff',
            color: '#0283C7',
            fontFamily: 'Inter, sans-serif',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.12)'
          }} data-id="element-131">
              Get a Free Quote
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button className="lg:hidden p-2 rounded-md" onClick={() => setIsOpen(!isOpen)} aria-label={isOpen ? 'Close menu' : 'Open menu'} aria-expanded={isOpen} data-id="element-132">
            {isOpen ? <XIcon className="h-6 w-6 text-white" data-id="element-133" /> : <MenuIcon className="h-6 w-6 text-white" data-id="element-134" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="lg:hidden border-t" style={{
      backgroundColor: '#025A8A',
      borderColor: 'rgba(255,255,255,0.15)'
    }} data-id="element-135">
          <nav className="px-4 py-4 flex flex-col gap-1" aria-label="Mobile navigation" data-id="element-136">
            {['Services', 'About Us', 'Locations', 'Reviews', 'Contact Us'].map(link => <a key={link} href={`#${link.toLowerCase().replace(/\s+/g, '-')}`} className="font-medium text-base text-white py-3 px-2 border-b transition-opacity hover:opacity-75" style={{
          borderColor: 'rgba(255,255,255,0.12)',
          fontFamily: 'Inter, sans-serif'
        }} onClick={() => setIsOpen(false)} data-id="element-137">
                  {link}
                </a>)}
            <div className="pt-4 flex flex-col gap-3" data-id="element-138">
              <a href="tel:4805998442" className="flex items-center justify-center gap-2 font-semibold text-base text-white py-3 rounded-lg border" style={{
            borderColor: 'rgba(255,255,255,0.4)',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-139">
                <PhoneIcon className="h-4 w-4" data-id="element-140" />
                (480) 599-8442
              </a>
              <a href="#contact" className="font-bold text-base text-center py-3 rounded-lg" style={{
            backgroundColor: '#ffffff',
            color: '#0283C7',
            fontFamily: 'Inter, sans-serif',
            borderRadius: '8px'
          }} onClick={() => setIsOpen(false)} data-id="element-141">
                Get a Free Quote
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}